import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mountain, Instagram, Facebook } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're subscribed! Welcome aboard.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="relative bg-[#0D1110] text-[#F9F8F6] pt-20 pb-10">
      <div className="noise-overlay" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-14 border-b border-white/10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 font-display font-extrabold text-xl">
              <Mountain className="w-6 h-6 text-primary" strokeWidth={2.5} />
              La Vida Is Travel Fit
            </div>
            <p className="mt-4 text-white/60 max-w-sm leading-relaxed">
              All-Inclusive Wellness Retreats in El Salvador. Train hard, travel far, live fit. Adults 18+ only.
            </p>
            <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-sm" data-testid="footer-newsletter">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                data-testid="newsletter-input"
                className="flex-1 h-11 rounded-full bg-white/10 border border-white/15 px-4 text-sm text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <button disabled={busy} data-testid="newsletter-submit" className="rounded-full bg-primary px-5 h-11 text-sm font-semibold hover:bg-[#B84726] transition-colors">
                Join
              </button>
            </form>
          </div>
          <div>
            <div className="overline text-primary mb-4">Explore</div>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/retreat" className="hover:text-primary">The Retreat</Link></li>
              <li><Link to="/why-el-salvador" className="hover:text-primary">Why El Salvador</Link></li>
              <li><Link to="/founders" className="hover:text-primary">Meet the Founders</Link></li>
              <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
              <li><Link to="/faq" className="hover:text-primary">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-primary mb-4">Legal</div>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/legal/privacy" className="hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/legal/terms" className="hover:text-primary">Terms & Conditions</Link></li>
              <li><Link to="/legal/cancellation" className="hover:text-primary">Cancellation & Refunds</Link></li>
              <li><Link to="/legal/waiver" className="hover:text-primary">Travel Waiver</Link></li>
              <li><Link to="/legal/insurance" className="hover:text-primary">Insurance Acknowledgment</Link></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/50">
          <p>&copy; {new Date().getFullYear()} La Vida Is Travel Fit · <a href="mailto:travelisvidainfo@gmail.com" className="hover:text-primary">travelisvidainfo@gmail.com</a></p>
          <div className="flex items-center gap-4">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:text-primary"><Instagram className="w-5 h-5" /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="hover:text-primary"><Facebook className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
